import {createElement} from 'react';
import {spring, Motion} from 'react-motion';
import {assoc} from '@packages/utilities/fp/utils';

const motionFactory = (props) => createElement(Motion, props);

export default (propName, springConfig, predicate) => (Component) => {
  const componentFactory = (factoryProps) =>
    createElement(Component, factoryProps);
  const setProp = assoc(propName);

  return (props) =>
    motionFactory({
      style: {
        [propName]:
          !predicate || predicate(props)
            ? spring(props[propName], springConfig)
            : props[propName],
      },
      children: (style) => componentFactory(setProp(style[propName])(props)),
    });
};
